import { Util } from "../../utils/util";
import { saveAppUserTokenIfAppView } from "../../utils/native-bridge";
import { ISignInResponse } from "../profile-service.interface";

/**
 * Shared sign-in tail for the Adora and None providers. Punchh opts out -- it wraps its calls
 * in a circuit breaker instead.
 */
export const withAppTokenHandoff = async (
    call: () => Promise<ISignInResponse>
): Promise<ISignInResponse> => {
    const result = await call();

    if (result.success)
        saveAppUserTokenIfAppView(Util.isAppView(), result.token);

    return result;
};
